
import { useState, useEffect } from 'react';
import { DataScroller } from 'primereact/datascroller';
import { getServiceCategory, getServiceImageByCategory } from '../../utilities/service.utilities';
import { getServices } from '../../service/servicePharma.service';
import { useLocation } from 'react-router-dom';
import React from 'react';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import { goTo } from '../../utilities/common.utilities';
import { useConnectivity } from '../../context/connectivityContext';
import "./service.component.css"

interface Service {
  categoryId: number;
  description: string;
  id: number;
  name:string;
  rating: number;
  subtitle: string;
}

export default function ServiceComponent() {
    const [services, setServices] = useState<Service[]>([]);

    // Variabile utilizzata per sapere se ci sono errori nella ricezione dei servizi come l' assenza di connessione.
    // Utilizzata per distinguere sul template, se la mancanza di servizi è dovuta ad errore oppure effettivamente non c'è ne sono.
    const [errorGetServices, setErrorGetServices] = useState<boolean>(false);
    const { isOnline } = useConnectivity();

    const location = useLocation();

    // Se non sono presenti dati in location.state, reindirizzo in home al posto
    // di far andare in errore il componente
    if(!location.state) {
        goTo('/home');
    }

    const { cardData } = location.state;
    const [isLoading, setLoader] = useState<boolean>(true);
    

    const getService = () => {

            getServices(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then(services => {
                let result: Service[] = [];
                setErrorGetServices(false);

                if(services?.items?.length > 0){
                    // services.item.map((x: Service) => {
                    //     result.push({
                    //         categoryId: x.categoryId,//getServiceCategory(x.categoryId),
                    //         description: x.description,
                    //         id: x.id,
                    //         name: x.name,
                    //         rating: x.rating,
                    //         subtitle: x.subtitle
                    //     })
                    // });
                    result = services.items;
                } 
                else if(!services) {
                    setErrorGetServices(true);
                    result = [];
                }
                else {
                    result = [];
                }

                if(result.length > 0){
                    setServices(result);
                  } else {
                    setServices([]);
                }

                setLoader(false);
            })
        //})
    }

    useEffect(() => {
        getService();
    }, [isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore

    const itemTemplate = (data: Service) => {
        return (

            <div
                className="col-12 bg-white mt-2 p-0 mb-4 custom-card">
                <div className="flex flex-column">
                        <img className='services-img-border' src={getServiceImageByCategory(data.categoryId)} alt={data.name}/>
                    <div className="p-2 pt-0">
                        <div className="flex overflow-hidden">
                            <div className="flex-grow-1 flex align-items-start justify-content-start">
                                <h2 className="mt-2 mb-0">{data.name}</h2>
                            </div>
                            {/* <div className="flex-none flex align-items-start justify-content-end mt-2 mb-0">
                                <i className={data.rating ? 'pi pi-thumbs-up-fill bg-white text-primary border-0' : 'pi pi-thumbs-up bg-white text-primary border-0' } style={{fontSize: '1.5rem'}}></i>
                            </div> */}
                        </div>

                        <div className="block mt-2">{data.description}</div>
                        
                    </div>
                </div>
            </div>
        );
    };

    return (
        <> 
        <div className="mt-2">
            <div className="flex justify-content-center">
                <h2 className="mb-0 mt-2">Servizi</h2>
            </div>
            <DataScroller 
            value={services} 
            itemTemplate={itemTemplate} 
            rows={100} 
            buffer={0.4} 
            header="" 
            // emptyMessage={
            //    
            //   }
            emptyMessage={() => {
                if(!errorGetServices) {
                    return (
                        <div className="text-center text-lg mt-5">
                            Nessun Servizio trovato
                        </div>
                    );
                }
                else {
                    return (
                        <div className='flex flex-column text-center text-lg mt-5'>

                            {
                                isOnline
                                ?
                                <></>
                                :
                                <div className='mb-3'>
                                <img src="./offline_globe.svg" alt="" className="img-offline-globe-empty-result"></img>
                                </div>
                            }

                            <div>Impossibile caricare i Servizi.</div>
                            {
                                navigator.onLine
                                ?
                                <></>
                                :
                                <div>Verifica la connessione internet.</div>
                            }
                            
                        </div>
                    )
                }
            }}
            />
        </div>
        </>
    )
}
        